import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { MeetingPage, MeetingPageTypeEx, RepositoryModal } from '../../shared'
import { MeetingPagesComponent } from './meeting-pages.component'

@Component({
    templateUrl: './meeting-page.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class MeetingPageComponent extends RepositoryModal<MeetingPage> implements OnInit {
    pageTypeList = MeetingPageTypeEx.ToListItems()

    ngOnInit() {
        const parentComponent = this.editOptions.initializeParams as MeetingPagesComponent
        if (this.isAdding) {
            this.target.meetingId = parentComponent.meetingId()
        }
    }
}
